export function isValidCategory(category: any): boolean {
  if (!category) {
    return false;
  }

  const {
    tier0, tier1, tier2, tier3,
  } = category;
  if (tier3 && (!tier0 || !tier1 || !tier2)) {
    return false;
  }
  if (tier2 && (!tier0 || !tier1)) {
    return false;
  }
  if (tier1 && !tier0) {
    return false;
  }
  if (!tier0) {
    return false;
  }
  return true;
}
